import { render } from "./modalPix.vue?vue&type=template&id=836fe27a"
import script from "./modalPix.vue?vue&type=script&lang=js"
export * from "./modalPix.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__